import { useState } from "react";
import { useParams } from "react-router-dom";

import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../ui/tabs";
import {
    ArrowLeft,
    CheckCircle,
    BarChart3,
    Activity,
    Bell,
    User,
    ChevronRight
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import AuditLogsDetails from "../AuditLogs/AuditLogsDetails";
import AlertDetails from "../Alerts/AlertsDetails";
import LolbinDetails from "../Lolbin/LolbinDetails";
import "../CloudAnalytics/CloudEntityAnalytics.css";
import "../Endpoints/DeviceDetails/DeviceDetailPage.css";
import "./ActiveDirectory.css";







export default function ADUserDetailsAnalytics() {
    const params = useParams();
    const [activeTab, setActiveTab] = useState("alerts");
    const [controlsContainer, setControlsContainer] = useState<HTMLDivElement | null>(null);
    const navigate = useNavigate();
    const computerEmail = params.name || '';
    const samAccountName = params.samAccountName || '';



    const detailTabs = [
        { id: "alerts", label: "Alerts", icon: Bell },
        { id: "lolbin", label: "Lolbin", icon: BarChart3 },
        { id: "activity", label: "Activity", icon: Activity },
    ];

    return (
        <div className="endpoint-detail-page ad-detail-page custom-scrollbar flex h-full min-h-0 min-w-0 flex-1 flex-col overflow-x-hidden overflow-y-auto bg-background">
            <div className="cea-header endpoint-detail-header">
                <div className="cea-entity-row endpoint-detail-entity-row">
                    <button
                        type="button"
                        onClick={() => navigate(-1)}
                        className="cea-back-icon-btn focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
                        aria-label="Back to AD Management"
                        title="Back to AD Management"
                        data-testid="button-back"
                    >
                        <ArrowLeft className="w-4 h-4" />
                    </button>

                    <div className="cea-avatar">
                        <User />
                    </div>
                    <div className="cea-entity-info endpoint-detail-entity-info">
                        <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                            <h1 className="cea-entity-name min-w-0" title={computerEmail} data-testid="text-entity-name">
                                {computerEmail}
                            </h1>
                            <span className="ad-detail-status">
                                <CheckCircle aria-hidden="true" />
                                Active
                            </span>
                        </div>
                        <div className="cea-entity-sub">
                            <span className="ad-detail-strong">{samAccountName}</span>
                        </div>
                        <nav aria-label="Breadcrumb" className="mt-3 flex flex-wrap items-center gap-1.5 text-xs text-muted-foreground">
                            <span>Active Directory</span>
                            <ChevronRight className="w-3.5 h-3.5 shrink-0" />
                            <span>Users</span>
                            <ChevronRight className="w-3.5 h-3.5 shrink-0" />
                            <span className="font-medium text-foreground break-all" aria-current="page">{computerEmail}</span>
                        </nav>
                    </div>
                    <div className="endpoint-detail-actions">
                        <div ref={setControlsContainer} className="endpoint-detail-controls ad-detail-controls" />
                    </div>
                </div>
            </div>

            <Tabs value={activeTab} onValueChange={setActiveTab} className="flex min-w-0 flex-none flex-col">
                <div className="endpoint-detail-tabs-wrapper">
                    <TabsList unstyled aria-label="User details" className="cea-tabs endpoint-detail-tabs custom-scrollbar">
                        {detailTabs.map((tab) => (
                            <TabsTrigger
                                unstyled
                                key={tab.id}
                                value={tab.id}
                                className={`cea-tab ${activeTab === tab.id ? "active" : ""}`}
                                data-testid={`tab-${tab.id}`}
                            >
                                <tab.icon className="shrink-0" />
                                {tab.label}
                            </TabsTrigger>
                        ))}
                    </TabsList>
                </div>

                <TabsContent value="lolbin" className="mt-0">
                    <LolbinDetails
                        fromdetails={true}
                        computerName=""
                        computeremail={samAccountName}
                        controlsContainer={controlsContainer}
                        showTopLolBins={true}
                        showTopUsers={false}
                        showTopComputers={true}
                    />
                </TabsContent>

                <TabsContent value="activity" className="mt-0">
                    <AuditLogsDetails fromdetails={true} computerName="" computeremail={samAccountName} controlsContainer={controlsContainer} />
                </TabsContent>

                <TabsContent value="alerts" className="mt-0">
                    <AlertDetails fromdetails={true} computerName="" computeremail={samAccountName} controlsContainer={controlsContainer} />
                </TabsContent>
            </Tabs>
        </div>
    );
}
